/* eslint-disable eol-last */
// import { html } from "lit";
// import { until } from "lit/directives/until.js";
// import { _converse, constants } from "@converse/headless";
// import { __ } from "i18n";
// import { getStandaloneButtons, getDropdownButtons } from "shared/chat/utils.js";

// const { HEADLINES_TYPE } = constants;

// /**
//  * @param {import('../heading').default} el
//  * @returns {import('lit').TemplateResult}
//  */
// export default (el) => {
//     const { jid, status, type } = el.model.attributes;
//     const heading_buttons_promise = el.getHeadingButtons();
//     const showUserDetailsModal = /** @param {Event} ev */ (ev) => el.showUserDetailsModal(ev);

//     const i18n_profile = __("The User's Profile Image");
//     const display_name = el.model.getDisplayName();
//     const avatar = html`<span title="${i18n_profile}">
//         <converse-avatar
//             .model=${el.model.contact || el.model}
//             class="avatar chat-msg__avatar"
//             name="${display_name}"
//             nonce=${el.model.contact?.vcard?.get("vcard_updated")}
//             height="40"
//             width="40"
//         ></converse-avatar
//     ></span>`;
//     return html`
//         <div class="chatbox-title ${status ? "" : "chatbox-title--no-desc"}">
//             <div class="chatbox-title--row">
//                 ${!_converse.api.settings.get("singleton")
//                     ? html`<converse-controlbox-navback jid="${jid}"></converse-controlbox-navback>`
//                     : ""}
//                 ${type !== HEADLINES_TYPE
//                     ? html`<a class="show-msg-author-modal" @click=${showUserDetailsModal}>${avatar}</a>`
//                     : ""}
//                 <div class="chatbox-title__text" title="${jid}" role="heading" aria-level="2">
//                     ${type !== HEADLINES_TYPE
//                         ? html`<a class="user show-msg-author-modal" @click=${showUserDetailsModal}>${display_name}</a>`
//                         : display_name}
//                 </div>
//             </div>
//             <div class="chatbox-title__buttons btn-toolbar g-0">
//                 ${until(getStandaloneButtons(heading_buttons_promise), "")}
//                 ${until(getDropdownButtons(heading_buttons_promise), "")}
//             </div>
//         </div>
//         ${status ? html`<p class="chat-head__desc">${status}</p>` : ""}
//     `;
// };
// import { html } from 'lit';
// import { until } from 'lit/directives/until.js';
// import { _converse, constants } from '@converse/headless';
// import { __ } from 'i18n';
// import { getStandaloneButtons, getDropdownButtons } from 'shared/chat/utils.js';

// const { HEADLINES_TYPE } = constants;

// /**
//  * @param {import('../heading').default} el
//  * @returns {import('lit').TemplateResult}
//  * */
// export default (el) => {
//     const { jid, status, type } = el.model.attributes;
//     const heading_buttons_promise = el.getHeadingButtons();
//     const showUserDetailsModal = /** @param {Event} ev */ (ev) => el.showUserDetailsModal(ev);

//     const i18n_profile = __("The User's Profile Image");

//     // === РЕЗЕРВНИЙ ФІКС ДЛЯ НАЗВИ ЧАТУ ===
//     // Якщо модель чатбоксу ще не має імені (повертає JID),
//     // пробуємо взяти fullname безпосередньо з об'єкта контакту чи ростера
//     let display_name = el.model.getDisplayName();
//     if (display_name === jid && el.model.contact) {
//         display_name = el.model.contact.get('fullname') || el.model.contact.get('name') || jid;
//     }

//     const avatar = html`<span title="${i18n_profile}">
//         <converse-avatar
//             .model=${el.model.contact || el.model}
//             class="avatar chat-msg__avatar"
//             name="${display_name}"
//             nonce=${el.model.contact?.vcard?.get('vcard_updated')}
//             height="40"
//             width="40"
//         ></converse-avatar>
//     </span>`;

//     return html`
//         <div class="chatbox-title ${status ? '' : 'chatbox-title--no-desc'}">
//             <div class="chatbox-title--row">
//                 ${!_converse.api.settings.get('singleton')
//                     ? html`<converse-controlbox-navback jid="${jid}"></converse-controlbox-navback>`
//                     : ''}
//                 ${type !== HEADLINES_TYPE
//                     ? html`<a class="show-msg-author-modal" @click=${showUserDetailsModal}>${avatar}</a>`
//                     : ''}
//                 <div class="chatbox-title__text" title="${jid}" role="heading" aria-level="2">
//                     ${type !== HEADLINES_TYPE
//                         ? html`<a class="user show-msg-author-modal" @click=${showUserDetailsModal}>${display_name}</a>`
//                         : display_name}
//                 </div>
//             </div>
//             <div class="chatbox-title__buttons btn-toolbar g-0">
//                 ${until(getStandaloneButtons(heading_buttons_promise), '')}
//                 ${until(getDropdownButtons(heading_buttons_promise), '')}
//             </div>
//         </div>
//         ${status ? html`<p class="chat-head__desc">${status}</p>` : ''}
//     `;
// };

// import { html } from 'lit';
// import { until } from 'lit/directives/until.js';
// import { _converse, constants } from '@converse/headless';
// import { __ } from 'i18n';
// import { getStandaloneButtons, getDropdownButtons } from 'shared/chat/utils.js';

// const { HEADLINES_TYPE } = constants;

// /**
//  * @param {import('../heading').default} el
//  * @returns {import('lit').TemplateResult}
//  * */
// export default (el) => {
//     const { jid, status, type } = el.model.attributes;
//     const heading_buttons_promise = el.getHeadingButtons();
//     const showUserDetailsModal = /** @param {Event} ev */ (ev) => el.showUserDetailsModal(ev);

//     // Виклик методу дзвінка, який ми перенесли в клас компонента
//     const onCallClick = (ev) => {
//         ev.preventDefault();
//         console.log('Ініціалізація дзвінка для JID:', jid);
//         el.initiateCall();
//     };

//     const i18n_profile = __("The User's Profile Image");
//     const i18n_call = __('Зателефонувати');

//     // === РЕЗЕРВНИЙ ФІКС ДЛЯ НАЗВИ ЧАТУ ===
//     let display_name = el.model.getDisplayName();
//     if (display_name === jid && el.model.contact) {
//         display_name = el.model.contact.get('fullname') || el.model.contact.get('name') || jid;
//     }

//     const avatar = html`<span title="${i18n_profile}">
//         <converse-avatar
//             .model=${el.model.contact || el.model}
//             class="avatar chat-msg__avatar"
//             name="${display_name}"
//             nonce=${el.model.contact?.vcard?.get('vcard_updated')}
//             height="40"
//             width="40"
//         ></converse-avatar>
//     </span>`;

//     return html`
//         <div class="chatbox-title ${status ? '' : 'chatbox-title--no-desc'}">
//             <div class="chatbox-title--row">
//                 ${!_converse.api.settings.get('singleton')
//                     ? html`<converse-controlbox-navback jid="${jid}"></converse-controlbox-navback>`
//                     : ''}
//                 ${type !== HEADLINES_TYPE
//                     ? html`<a class="show-msg-author-modal" @click=${showUserDetailsModal}>${avatar}</a>`
//                     : ''}
//                 <div class="chatbox-title__text" title="${jid}" role="heading" aria-level="2">
//                     ${type !== HEADLINES_TYPE
//                         ? html`<a class="user show-msg-author-modal" @click=${showUserDetailsModal}>${display_name}</a>`
//                         : display_name}
//                 </div>
//             </div>

//             <div class="chatbox-title__buttons btn-toolbar g-0 align-items-center">
//                 ${type !== HEADLINES_TYPE
//                     ? html`
//                           <button
//                               type="button"
//                               class="btn btn-icon chatbox-btn-call"
//                               title="${i18n_call}"
//                               @click=${onCallClick}
//                               style="background: transparent; border: none; padding: 0 8px; height: 100%; display: inline-flex; align-items: center; justify-content: center; box-shadow: none;"
//                           >
//                               <converse-icon
//                                   size="1.2em"
//                                   class="fa fa-phone"
//                                   path-prefix="/dist"
//                                   style="display: inline-flex;"
//                               >
//                               </converse-icon>
//                           </button>
//                       `
//                     : ''}
//                 ${until(getStandaloneButtons(heading_buttons_promise), '')}
//                 ${until(getDropdownButtons(heading_buttons_promise), '')}
//             </div>
//         </div>
//         ${status ? html`<p class="chat-head__desc">${status}</p>` : ''}
//     `;
// };

//ui ready
// import { html } from 'lit';
// import { until } from 'lit/directives/until.js';
// import { _converse, constants } from '@converse/headless';
// import { __ } from 'i18n';
// import { getStandaloneButtons, getDropdownButtons } from 'shared/chat/utils.js';

// const { HEADLINES_TYPE } = constants;

// /**
//  * @param {import('../heading').default} el
//  * @returns {import('lit').TemplateResult}
//  */
// export default (el) => {
//     const { jid, status, type } = el.model.attributes;
//     const heading_buttons_promise = el.getHeadingButtons();
//     const showUserDetailsModal = (ev) => el.showUserDetailsModal(ev);

//     const onAudioCallClick = (ev) => {
//         ev.preventDefault();
//         console.log('[chat-head] Audio call click for JID:', jid);
//         el.initiateCall('audio');
//     };

//     const onVideoCallClick = (ev) => {
//         ev.preventDefault();
//         console.log('[chat-head] Video call click for JID:', jid);
//         el.initiateCall('video');
//     };

//     const i18n_profile = __("The User's Profile Image");
//     const i18n_audio_call = __('Аудіодзвінок');
//     const i18n_video_call = __('Відеодзвінок');

//     let display_name = el.model.getDisplayName();
//     if (display_name === jid && el.model.contact) {
//         display_name = el.model.contact.get('fullname') || el.model.contact.get('name') || jid;
//     }

//     const avatar = html`<span title="${i18n_profile}">
//         <converse-avatar
//             .model=${el.model.contact || el.model}
//             class="avatar chat-msg__avatar"
//             name="${display_name}"
//             nonce=${el.model.contact?.vcard?.get('vcard_updated')}
//             height="40"
//             width="40"
//         ></converse-avatar>
//     </span>`;

//     // Shared button style — matches the existing audio call button
//     const btnStyle = [
//         'background: transparent',
//         'border: none',
//         'padding: 0 6px',
//         'height: 100%',
//         'display: inline-flex',
//         'align-items: center',
//         'justify-content: center',
//         'box-shadow: none',
//         'cursor: pointer',
//         'color: var(--text-color, inherit)',
//     ].join('; ');

//     return html`
//         <div class="chatbox-title ${status ? '' : 'chatbox-title--no-desc'}">
//             <div class="chatbox-title--row">
//                 ${!_converse.api.settings.get('singleton')
//                     ? html`<converse-controlbox-navback jid="${jid}"></converse-controlbox-navback>`
//                     : ''}
//                 ${type !== HEADLINES_TYPE
//                     ? html`<a class="show-msg-author-modal" @click=${showUserDetailsModal}>${avatar}</a>`
//                     : ''}
//                 <div class="chatbox-title__text" title="${jid}" role="heading" aria-level="2">
//                     ${type !== HEADLINES_TYPE
//                         ? html`<a class="user show-msg-author-modal" @click=${showUserDetailsModal}>${display_name}</a>`
//                         : display_name}
//                 </div>
//             </div>

//             <div class="chatbox-title__buttons btn-toolbar g-0 align-items-center">
//                 ${type !== HEADLINES_TYPE
//                     ? html`
//                           <!-- Audio call button — uses converse-icon same as before -->
//                           <button
//                               type="button"
//                               class="btn btn-icon chatbox-btn-call"
//                               title="${i18n_audio_call}"
//                               @click=${onAudioCallClick}
//                               style="${btnStyle}"
//                           >
//                               <svg
//                                   width="40"
//                                   height="40"
//                                   viewBox="0 0 40 40"
//                                   fill="none"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   style="display: inline-flex;"
//                               >
//                                   <path
//                                       d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
//                                       fill="#253E75"
//                                   />
//                                   <path
//                                       d="M28.5188 26.1975C28.5188 25.4819 28.5111 25.2823 28.4609 25.1187L28.46 25.1178C28.3878 24.8808 28.2503 24.6688 28.0631 24.5066L28.0613 24.5048C27.9331 24.3932 27.755 24.3063 27.101 24.0147L26.1688 23.6014C25.4591 23.2864 25.26 23.2068 25.0737 23.1891C24.9198 23.1744 24.7642 23.1874 24.6153 23.2262L24.4679 23.2732C24.3369 23.3243 24.2077 23.4109 23.9001 23.6602L23.5266 23.9686C23.0123 24.3967 22.6269 24.7304 22.1414 24.908L22.135 24.9098L22.1287 24.9126C21.6969 25.0618 21.2364 25.1091 20.7832 25.0509L20.7715 25.0491C20.2611 24.9753 19.867 24.7544 19.3555 24.4812C17.5342 23.507 16.4943 22.4673 15.5198 20.6446C15.2456 20.1311 15.026 19.739 14.951 19.2304L14.9492 19.2178C14.8908 18.7651 14.938 18.3047 15.0867 17.8732L15.0885 17.8668L15.0912 17.8605C15.2689 17.3732 15.6043 16.9867 16.0316 16.4734L16.3408 16.0991C16.5902 15.7916 16.6758 15.6636 16.726 15.5339L16.7269 15.5321C16.802 15.3397 16.8307 15.1322 16.811 14.9272V14.9236C16.794 14.7393 16.7156 14.5415 16.3996 13.8322L15.9348 12.7905H15.9366C15.7519 12.3765 15.6572 12.1764 15.5777 12.0509L15.4936 11.9369C15.3313 11.7497 15.1193 11.6122 14.8823 11.54L14.8814 11.5391C14.7178 11.4889 14.5182 11.4812 13.8027 11.4812C13.3035 11.4812 12.9712 11.4824 12.7122 11.5029C12.4728 11.5219 12.3433 11.5547 12.2474 11.5969C11.9192 11.7583 11.665 12.0388 11.5358 12.3809C11.4563 12.6166 11.4656 12.8708 11.5548 13.7969C11.9925 18.3326 13.4455 21.7579 15.8444 24.1566C18.2433 26.5552 21.6682 28.0077 26.204 28.4454C27.133 28.535 27.3857 28.5435 27.6236 28.4625C27.9637 28.3329 28.2415 28.0794 28.4022 27.7527C28.4445 27.6561 28.4782 27.5266 28.4971 27.288C28.5177 27.0288 28.5188 26.6967 28.5188 26.1975ZM29.9999 26.1975C29.9999 26.6734 30.0008 27.0735 29.9746 27.4046C29.9474 27.7471 29.8884 28.0658 29.7458 28.3785L29.7422 28.3875L29.7386 28.3956C29.4099 29.0715 28.8327 29.5942 28.1282 29.856L28.1201 29.8596L28.1119 29.8623C27.4997 30.0736 26.8755 29.9986 26.0621 29.9202C21.2866 29.4593 17.5025 27.9097 14.7964 25.2037C12.0905 22.4978 10.5409 18.7148 10.08 13.9398C10.0016 13.1254 9.92607 12.4999 10.1379 11.8881L10.1406 11.8809L10.1442 11.8727C10.4061 11.1675 10.9297 10.5902 11.6063 10.2614L11.6136 10.2578L11.6217 10.2542C11.9343 10.1112 12.2532 10.0526 12.5956 10.0254C12.9265 9.99916 13.3267 10.0001 13.8027 10.0001C14.4217 10.0001 14.8887 9.9923 15.3154 10.1231L15.3145 10.124C15.8176 10.2774 16.2674 10.5685 16.6121 10.9658C16.9045 11.3028 17.0877 11.7319 17.3391 12.2977L18.2171 14.2716H18.1773C18.231 14.445 18.2697 14.6133 18.2858 14.7852L18.2966 14.9489C18.3108 15.3315 18.2462 15.7138 18.1068 16.0711C17.9306 16.5247 17.5977 16.9087 17.17 17.422L17.1691 17.4211C16.6816 18.0067 16.5542 18.1751 16.4846 18.3624C16.413 18.5736 16.3903 18.7984 16.4177 19.0197C16.4481 19.2205 16.5209 19.3744 16.8264 19.9466C17.6623 21.5099 18.4901 22.3376 20.0526 23.1737C20.6242 23.479 20.7782 23.5517 20.9758 23.5815C21.1985 23.6095 21.4243 23.5859 21.6368 23.5137C21.8242 23.4441 21.9928 23.3173 22.5781 22.8301C23.0937 22.4004 23.4762 22.0701 23.929 21.8934L24.0836 21.8382C24.4477 21.7201 24.8327 21.6776 25.2148 21.7143C25.6994 21.7604 26.1587 21.9755 26.7701 22.2469L27.7014 22.6601L27.7032 22.661C28.2654 22.9117 28.6984 23.0946 29.0351 23.388C29.4323 23.7326 29.7235 24.1818 29.8769 24.6847L29.9194 24.8466C30.0056 25.2304 29.9999 25.6557 29.9999 26.1975Z"
//                                       fill="#9AB9FF"
//                                   />
//                               </svg>
//                           </button>

//                           <button
//                               type="button"
//                               class="btn btn-icon chatbox-btn-video-call"
//                               title="${i18n_video_call}"
//                               @click=${onVideoCallClick}
//                               style="${btnStyle}"
//                           >
//                               <svg
//                                   width="40"
//                                   height="40"
//                                   viewBox="0 0 40 40"
//                                   fill="none"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                   style="display: inline-flex;"
//                               >
//                                   <path
//                                       d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
//                                       fill="#253E75"
//                                   />
//                                   <path
//                                       d="M24.278 17.7433C24.278 16.8683 24.2775 16.2611 24.2393 15.7892C24.2017 15.3269 24.1316 15.0668 24.0334 14.8727C23.8186 14.4483 23.476 14.1034 23.0546 13.8871C22.8618 13.7882 22.6035 13.7175 22.1445 13.6797C21.6759 13.6412 21.0729 13.6407 20.2039 13.6407H14.7034C13.8344 13.6407 13.2314 13.6412 12.7628 13.6797C12.3038 13.7175 12.0455 13.7882 11.8527 13.8871C11.4313 14.1034 11.0887 14.4483 10.874 14.8727C10.7757 15.0668 10.7056 15.3269 10.6681 15.7892C10.6298 16.2611 10.6293 16.8683 10.6293 17.7433V22.2567C10.6293 23.1317 10.6298 23.7389 10.6681 24.2108C10.7056 24.6731 10.7757 24.9332 10.874 25.1273C11.0887 25.5517 11.4313 25.8966 11.8527 26.1129C12.0455 26.2118 12.3038 26.2825 12.7628 26.3203C13.2314 26.3588 13.8344 26.3593 14.7034 26.3593H20.2039C21.0729 26.3593 21.6759 26.3588 22.1445 26.3203C22.6035 26.2825 22.8618 26.2118 23.0546 26.1129C23.476 25.8966 23.8186 25.5517 24.0334 25.1273C24.1316 24.9332 24.2017 24.6731 24.2393 24.2108C24.2775 23.7389 24.278 23.1317 24.278 22.2567V17.7433ZM26.2445 20L29.3707 23.1471V16.8529L26.2445 20ZM31 23.1471C31 23.4414 31.0012 23.7182 30.9821 23.9364C30.9652 24.1277 30.9223 24.4731 30.6827 24.7557C30.4075 25.0802 29.9999 25.2528 29.5726 25.2195C29.2048 25.1903 28.9321 24.9762 28.7859 24.8529C28.619 24.7122 28.4247 24.5162 28.2179 24.308L25.9073 21.9802V22.2567C25.9073 23.1046 25.9085 23.7899 25.8635 24.3441C25.8178 24.9079 25.7204 25.4085 25.4856 25.8725C25.1145 26.6056 24.5226 27.2017 23.7946 27.5753C23.3338 27.8118 22.8367 27.9099 22.2768 27.9559C21.7265 28.0012 21.0459 28 20.2039 28H14.7034C13.8614 28 13.1809 28.0012 12.6305 27.9559C12.0706 27.9099 11.5735 27.8118 11.1127 27.5753C10.3847 27.2017 9.79276 26.6056 9.42174 25.8725C9.18694 25.4085 9.08952 24.9079 9.04377 24.3441C8.99882 23.7899 9 23.1046 9 22.2567V17.7433C9 16.8954 8.99882 16.2101 9.04377 15.6559C9.08952 15.0921 9.18694 14.5915 9.42174 14.1275C9.79276 13.3944 10.3847 12.7983 11.1127 12.4247C11.5735 12.1882 12.0706 12.0901 12.6305 12.0441C13.1809 11.9988 13.8614 12 14.7034 12H20.2039C21.0459 12 21.7265 11.9988 22.2768 12.0441C22.8367 12.0901 23.3338 12.1882 23.7946 12.4247C24.5226 12.7983 25.1145 13.3944 25.4856 14.1275C25.7204 14.5915 25.8178 15.0921 25.8635 15.6559C25.9085 16.2101 25.9073 16.8954 25.9073 17.7433V18.0188L28.2179 15.692C28.4247 15.4838 28.619 15.2878 28.7859 15.1471C28.9321 15.0238 29.2048 14.8097 29.5726 14.7805L29.7298 14.7775C30.0433 14.7903 30.3425 14.915 30.5733 15.1291L30.6827 15.2443L30.7642 15.3524C30.933 15.6105 30.9674 15.8963 30.9821 16.0636C31.0012 16.2818 31 16.5587 31 16.8529V23.1471Z"
//                                       fill="#9AB9FF"
//                                   />
//                               </svg>
//                           </button>
//                       `
//                     : ''}
//                 ${until(getStandaloneButtons(heading_buttons_promise), '')}
//                 ${until(getDropdownButtons(heading_buttons_promise), '')}
//             </div>
//         </div>
//         ${status ? html`<p class="chat-head__desc">${status}</p>` : ''}
//     `;
// };

import { html } from 'lit';
import { until } from 'lit/directives/until.js';
import { _converse, constants } from '@converse/headless';
import { __ } from 'i18n';
import { getStandaloneButtons, getDropdownButtons } from 'shared/chat/utils.js';

const { HEADLINES_TYPE } = constants;

/**
 * @param {import('../heading').default} el
 * @returns {import('lit').TemplateResult}
 */
export default (el) => {
    const { jid, status, type } = el.model.attributes;
    const heading_buttons_promise = el.getHeadingButtons();
    const showUserDetailsModal = (ev) => el.showUserDetailsModal(ev);

    // callActive is a reactive property on ChatHeading — true while any call
    // is active or pending (set via setActiveCall() helper in heading.js).
    // When true, call buttons are disabled and dimmed to prevent double-calls.
    const callActive = el.callActive ?? false;

    const onAudioCallClick = (ev) => {
        ev.preventDefault();
        if (callActive) return;
        console.log('[chat-head] Audio call click for JID:', jid);
        el.initiateCall('audio');
    };

    const onVideoCallClick = (ev) => {
        ev.preventDefault();
        if (callActive) return;
        console.log('[chat-head] Video call click for JID:', jid);
        el.initiateCall('video');
    };

    const i18n_profile = __("The User's Profile Image");
    const i18n_audio_call = __('Аудіодзвінок');
    const i18n_video_call = __('Відеодзвінок');
    const i18n_call_busy = __('Дзвінок вже активний');

    let display_name = el.model.getDisplayName();
    if (display_name === jid && el.model.contact) {
        display_name = el.model.contact.get('fullname') || el.model.contact.get('name') || jid;
    }

    const avatar = html`<span title="${i18n_profile}"><converse-avatar .model="${el.model.contact || el.model}" class="avatar chat-msg__avatar" name="${display_name}" nonce="${el.model.contact?.vcard?.get('vcard_updated')}" height="40" width="40"></converse-avatar></span>`;

    // Base button style. When callActive, opacity is reduced and cursor blocked.
    const btnStyle = [
        'background: transparent',
        'border: none',
        'padding: 0 6px',
        'height: 100%',
        'display: inline-flex',
        'align-items: center',
        'justify-content: center',
        'box-shadow: none',
        `cursor: ${callActive ? 'not-allowed' : 'pointer'}`,
        `opacity: ${callActive ? '0.4' : '1'}`,
        'color: var(--text-color, inherit)',
        'transition: opacity 0.2s',
    ].join('; ');

    return html`<div class="chatbox-title ${status ? '' : 'chatbox-title--no-desc'}"><div class="chatbox-title--row">${!_converse.api.settings.get('singleton')
                    ? html`<converse-controlbox-navback jid="${jid}"></converse-controlbox-navback>`
                    : ''} ${type !== HEADLINES_TYPE
                    ? html`<a class="show-msg-author-modal" @click="${showUserDetailsModal}">${avatar}</a>`
                    : ''}<div class="chatbox-title__text" title="${jid}" role="heading" aria-level="2">${type !== HEADLINES_TYPE
                        ? html`<a class="user show-msg-author-modal" @click="${showUserDetailsModal}">${display_name}</a>`
                        : display_name}</div></div><div class="chatbox-title__buttons btn-toolbar g-0 align-items-center">${type !== HEADLINES_TYPE
                    ? html`<button type="button" class="btn btn-icon chatbox-btn-call" title="${callActive ? i18n_call_busy : i18n_audio_call}" ?disabled="${callActive}" @click="${onAudioCallClick}" style="${btnStyle}"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:inline-flex"><path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#253E75"/><path d="M28.5188 26.1975C28.5188 25.4819 28.5111 25.2823 28.4609 25.1187L28.46 25.1178C28.3878 24.8808 28.2503 24.6688 28.0631 24.5066L28.0613 24.5048C27.9331 24.3932 27.755 24.3063 27.101 24.0147L26.1688 23.6014C25.4591 23.2864 25.26 23.2068 25.0737 23.1891C24.9198 23.1744 24.7642 23.1874 24.6153 23.2262L24.4679 23.2732C24.3369 23.3243 24.2077 23.4109 23.9001 23.6602L23.5266 23.9686C23.0123 24.3967 22.6269 24.7304 22.1414 24.908L22.135 24.9098L22.1287 24.9126C21.6969 25.0618 21.2364 25.1091 20.7832 25.0509L20.7715 25.0491C20.2611 24.9753 19.867 24.7544 19.3555 24.4812C17.5342 23.507 16.4943 22.4673 15.5198 20.6446C15.2456 20.1311 15.026 19.739 14.951 19.2304L14.9492 19.2178C14.8908 18.7651 14.938 18.3047 15.0867 17.8732L15.0885 17.8668L15.0912 17.8605C15.2689 17.3732 15.6043 16.9867 16.0316 16.4734L16.3408 16.0991C16.5902 15.7916 16.6758 15.6636 16.726 15.5339L16.7269 15.5321C16.802 15.3397 16.8307 15.1322 16.811 14.9272V14.9236C16.794 14.7393 16.7156 14.5415 16.3996 13.8322L15.9348 12.7905H15.9366C15.7519 12.3765 15.6572 12.1764 15.5777 12.0509L15.4936 11.9369C15.3313 11.7497 15.1193 11.6122 14.8823 11.54L14.8814 11.5391C14.7178 11.4889 14.5182 11.4812 13.8027 11.4812C13.3035 11.4812 12.9712 11.4824 12.7122 11.5029C12.4728 11.5219 12.3433 11.5547 12.2474 11.5969C11.9192 11.7583 11.665 12.0388 11.5358 12.3809C11.4563 12.6166 11.4656 12.8708 11.5548 13.7969C11.9925 18.3326 13.4455 21.7579 15.8444 24.1566C18.2433 26.5552 21.6682 28.0077 26.204 28.4454C27.133 28.535 27.3857 28.5435 27.6236 28.4625C27.9637 28.3329 28.2415 28.0794 28.4022 27.7527C28.4445 27.6561 28.4782 27.5266 28.4971 27.288C28.5177 27.0288 28.5188 26.6967 28.5188 26.1975ZM29.9999 26.1975C29.9999 26.6734 30.0008 27.0735 29.9746 27.4046C29.9474 27.7471 29.8884 28.0658 29.7458 28.3785L29.7422 28.3875L29.7386 28.3956C29.4099 29.0715 28.8327 29.5942 28.1282 29.856L28.1201 29.8596L28.1119 29.8623C27.4997 30.0736 26.8755 29.9986 26.0621 29.9202C21.2866 29.4593 17.5025 27.9097 14.7964 25.2037C12.0905 22.4978 10.5409 18.7148 10.08 13.9398C10.0016 13.1254 9.92607 12.4999 10.1379 11.8881L10.1406 11.8809L10.1442 11.8727C10.4061 11.1675 10.9297 10.5902 11.6063 10.2614L11.6136 10.2578L11.6217 10.2542C11.9343 10.1112 12.2532 10.0526 12.5956 10.0254C12.9265 9.99916 13.3267 10.0001 13.8027 10.0001C14.4217 10.0001 14.8887 9.9923 15.3154 10.1231L15.3145 10.124C15.8176 10.2774 16.2674 10.5685 16.6121 10.9658C16.9045 11.3028 17.0877 11.7319 17.3391 12.2977L18.2171 14.2716H18.1773C18.231 14.445 18.2697 14.6133 18.2858 14.7852L18.2966 14.9489C18.3108 15.3315 18.2462 15.7138 18.1068 16.0711C17.9306 16.5247 17.5977 16.9087 17.17 17.422L17.1691 17.4211C16.6816 18.0067 16.5542 18.1751 16.4846 18.3624C16.413 18.5736 16.3903 18.7984 16.4177 19.0197C16.4481 19.2205 16.5209 19.3744 16.8264 19.9466C17.6623 21.5099 18.4901 22.3376 20.0526 23.1737C20.6242 23.479 20.7782 23.5517 20.9758 23.5815C21.1985 23.6095 21.4243 23.5859 21.6368 23.5137C21.8242 23.4441 21.9928 23.3173 22.5781 22.8301C23.0937 22.4004 23.4762 22.0701 23.929 21.8934L24.0836 21.8382C24.4477 21.7201 24.8327 21.6776 25.2148 21.7143C25.6994 21.7604 26.1587 21.9755 26.7701 22.2469L27.7014 22.6601L27.7032 22.661C28.2654 22.9117 28.6984 23.0946 29.0351 23.388C29.4323 23.7326 29.7235 24.1818 29.8769 24.6847L29.9194 24.8466C30.0056 25.2304 29.9999 25.6557 29.9999 26.1975Z" fill="#9AB9FF"/></svg></button> <button type="button" class="btn btn-icon chatbox-btn-video-call" title="${callActive ? i18n_call_busy : i18n_video_call}" ?disabled="${callActive}" @click="${onVideoCallClick}" style="${btnStyle}"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:inline-flex"><path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#253E75"/><path d="M24.278 17.7433C24.278 16.8683 24.2775 16.2611 24.2393 15.7892C24.2017 15.3269 24.1316 15.0668 24.0334 14.8727C23.8186 14.4483 23.476 14.1034 23.0546 13.8871C22.8618 13.7882 22.6035 13.7175 22.1445 13.6797C21.6759 13.6412 21.0729 13.6407 20.2039 13.6407H14.7034C13.8344 13.6407 13.2314 13.6412 12.7628 13.6797C12.3038 13.7175 12.0455 13.7882 11.8527 13.8871C11.4313 14.1034 11.0887 14.4483 10.874 14.8727C10.7757 15.0668 10.7056 15.3269 10.6681 15.7892C10.6298 16.2611 10.6293 16.8683 10.6293 17.7433V22.2567C10.6293 23.1317 10.6298 23.7389 10.6681 24.2108C10.7056 24.6731 10.7757 24.9332 10.874 25.1273C11.0887 25.5517 11.4313 25.8966 11.8527 26.1129C12.0455 26.2118 12.3038 26.2825 12.7628 26.3203C13.2314 26.3588 13.8344 26.3593 14.7034 26.3593H20.2039C21.0729 26.3593 21.6759 26.3588 22.1445 26.3203C22.6035 26.2825 22.8618 26.2118 23.0546 26.1129C23.476 25.8966 23.8186 25.5517 24.0334 25.1273C24.1316 24.9332 24.2017 24.6731 24.2393 24.2108C24.2775 23.7389 24.278 23.1317 24.278 22.2567V17.7433ZM26.2445 20L29.3707 23.1471V16.8529L26.2445 20ZM31 23.1471C31 23.4414 31.0012 23.7182 30.9821 23.9364C30.9652 24.1277 30.9223 24.4731 30.6827 24.7557C30.4075 25.0802 29.9999 25.2528 29.5726 25.2195C29.2048 25.1903 28.9321 24.9762 28.7859 24.8529C28.619 24.7122 28.4247 24.5162 28.2179 24.308L25.9073 21.9802V22.2567C25.9073 23.1046 25.9085 23.7899 25.8635 24.3441C25.8178 24.9079 25.7204 25.4085 25.4856 25.8725C25.1145 26.6056 24.5226 27.2017 23.7946 27.5753C23.3338 27.8118 22.8367 27.9099 22.2768 27.9559C21.7265 28.0012 21.0459 28 20.2039 28H14.7034C13.8614 28 13.1809 28.0012 12.6305 27.9559C12.0706 27.9099 11.5735 27.8118 11.1127 27.5753C10.3847 27.2017 9.79276 26.6056 9.42174 25.8725C9.18694 25.4085 9.08952 24.9079 9.04377 24.3441C8.99882 23.7899 9 23.1046 9 22.2567V17.7433C9 16.8954 8.99882 16.2101 9.04377 15.6559C9.08952 15.0921 9.18694 14.5915 9.42174 14.1275C9.79276 13.3944 10.3847 12.7983 11.1127 12.4247C11.5735 12.1882 12.0706 12.0901 12.6305 12.0441C13.1809 11.9988 13.8614 12 14.7034 12H20.2039C21.0459 12 21.7265 11.9988 22.2768 12.0441C22.8367 12.0901 23.3338 12.1882 23.7946 12.4247C24.5226 12.7983 25.1145 13.3944 25.4856 14.1275C25.7204 14.5915 25.8178 15.0921 25.8635 15.6559C25.9085 16.2101 25.9073 16.8954 25.9073 17.7433V18.0188L28.2179 15.692C28.4247 15.4838 28.619 15.2878 28.7859 15.1471C28.9321 15.0238 29.2048 14.8097 29.5726 14.7805L29.7298 14.7775C30.0433 14.7903 30.3425 14.915 30.5733 15.1291L30.6827 15.2443L30.7642 15.3524C30.933 15.6105 30.9674 15.8963 30.9821 16.0636C31.0012 16.2818 31 16.5587 31 16.8529V23.1471Z" fill="#9AB9FF"/></svg></button>`
                    : ''} ${until(getStandaloneButtons(heading_buttons_promise), '')} ${until(getDropdownButtons(heading_buttons_promise), '')}</div></div>${status ? html`<p class="chat-head__desc">${status}</p>` : ''}`;
};
